import adminTable from '@store/adminTable/reducers';

import { question } from '@Modules/Question/configs/constants';

export default adminTable(question);
